/* The Balcony Garden – Florida landing page */
(function () {
  var d = document;
  d.documentElement.classList.add('tfl-js');

  function ready(fn) { d.readyState !== 'loading' ? fn() : d.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // 1. Carry ad tracking tags (utm_*, fbclid) onto every link, so sales stay tied to the right ad.
    var q = location.search;
    if (q) {
      var keep = new URLSearchParams();
      new URLSearchParams(q).forEach(function (v, k) {
        if (/^utm_|^fbclid$|^gclid$|^ttclid$/.test(k)) keep.set(k, v);
      });
      if ([...keep.keys()].length) {
        d.querySelectorAll('.tfl a[href]').forEach(function (a) {
          var h = a.getAttribute('href');
          if (!h || h.charAt(0) === '#' || /^(mailto|tel):/.test(h)) return;
          try {
            var u = new URL(a.href, location.origin);
            if (u.origin !== location.origin) return;
            keep.forEach(function (v, k) { if (!u.searchParams.has(k)) u.searchParams.set(k, v); });
            a.href = u.pathname + u.search + u.hash;
          } catch (e) {}
        });
      }
    }

    // 2. Reveal sections as they scroll in.
    var els = d.querySelectorAll('.tfl-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else { els.forEach(function (el) { el.classList.add('is-in'); }); }

    // 3. Swipe progress bars under the sideways-scrolling rows.
    d.querySelectorAll('[data-tfl-swipe]').forEach(function (row) {
      var bar = row.parentNode.querySelector('.tfl-swipe-hint i span');
      if (!bar) return;
      function upd() {
        var max = row.scrollWidth - row.clientWidth;
        var vis = row.clientWidth / row.scrollWidth;
        bar.style.width = Math.max(vis * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (max > 0 ? (row.scrollLeft / max) * ((1 / Math.max(vis, .12)) - 1) * 100 : 0) + '%)';
      }
      row.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });

    // 4. Sticky "Shop" bar on phones: shows after the hero, hides when the closing banner or footer is on screen.
    var bar = d.querySelector('.tfl-sticky');
    if (bar) {
      d.body.classList.add('tfl-has-sticky');
      var hero = d.querySelector('.tfl-hero');
      var stops = d.querySelectorAll('.tfl-cta, footer, .footer, #shopify-section-footer');
      var pastHero = !hero, nearEnd = false;
      function paint() { bar.classList.toggle('is-on', pastHero && !nearEnd); }
      if ('IntersectionObserver' in window) {
        if (hero) new IntersectionObserver(function (es) { pastHero = !es[0].isIntersecting; paint(); }, { threshold: 0.05 }).observe(hero);
        var seen = new Set();
        var so = new IntersectionObserver(function (es) {
          es.forEach(function (e) { e.isIntersecting ? seen.add(e.target) : seen.delete(e.target); });
          nearEnd = seen.size > 0; paint();
        });
        stops.forEach(function (s) { so.observe(s); });
      } else { pastHero = true; paint(); }
    }
  });
})();
